import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Contact } from './pages/Contact';
import { Legal } from './pages/Legal';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31c9ygdv1bhw7">
      <ScrollToTop data-id="element-1" data-mp="31cjmvx0flgzs" />
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-2" data-mp="2wka20ve6b74d">
        <Header data-id="element-3" data-mp="2whx9xpepbgdl" />
        <div className="flex-1" data-id="element-4" data-mp="28ufpkexrnkkn">
          <Routes data-id="element-5" data-mp="28tmdqzjya4vn">
            <Route path="/" element={<Home data-id="element-7" data-mp="28sbb5328r364" />} data-id="element-6" data-mp="28t4ju9krg2qw" />
            <Route path="/about" element={<About data-id="element-9" data-mp="23w4ey1znd61d" />} data-id="element-8" data-mp="23vci6nubd29i" />
            <Route path="/services" element={<Services data-id="element-11" data-mp="23ti7018ugoim" />} data-id="element-10" data-mp="23utbk3a460as" />
            <Route path="/services/:slug" element={<ServiceDetail data-id="element-13" data-mp="3ijfw82xf22g7" />} data-id="element-12" data-mp="3ikha0f5th31m" />
            <Route path="/contact" element={<Contact data-id="element-15" data-mp="3ml17jjuay8oa" />} data-id="element-14" data-mp="3ii4qhxkeukmg" />
            <Route path="/legal" element={<Legal data-id="element-17" data-mp="3mjg8pi0yg3km" />} data-id="element-16" data-mp="3mk84otygs3bf" />
            <Route path="/legal/:slug" element={<Legal data-id="element-19" data-mp="3rdatypw7kqlt" />} data-id="element-18" data-mp="3rcj6k2crlz6m" />
            <Route path="*" element={<Home data-id="element-21" data-mp="5yk6vxnnffx" />} data-id="element-20" data-mp="3rd19fhtxnbni" />
          </Routes>
        </div>
        <Footer data-id="element-22" data-mp="4n6o4eeqtbm" />
      </div>
    </BrowserRouter>;
}